<template>
  <div id="measure-create-modal">
    <v-dialog v-model="modal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">新しい計測を開始する</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  label="デバイスID"
                  v-model="form.deviceId"
                  :items="deviceIds"
                  :rules="validation.deviceId"
                  required
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="グラフの種類"
                  v-model="form.template_type"
                  :items="templateTypeOptions"
                  item-text="text"
                  item-value="value"
                  required
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="測定モード"
                  v-model="form.mode"
                  :items="modeOptions"
                  item-text="text"
                  item-value="value"
                  required
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="名称"
                  v-model="form.name"
                  :rules="validation.name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="説明"
                  v-model="form.description"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="公開グループ名"
                  v-model="form.siteGroup"
                  :items="siteGroupOption"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('close')" text>閉じる</v-btn>
          <v-btn @click="$emit('submit', form)" text :disabled="!valid"
            >登録する</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "measure-create-modal",
  data() {
    return {
      form: {
        deviceId: null,
        template_type: "static_strain",
        mode: 0,
        name: "",
        description: "",
        siteGroup: "",
      },
      templateTypeOptions: [
        { text: "デフォルト", value: "static_strain" },
        { text: "軸力（３段階管理値）", value: "axial_load" },
      ],
      modeOptions: [
        { text: "ひずみ4ch, Full", value: 0 },
        { text: "ひずみ4ch, Low", value: 1 },
        { text: "ひずみ3ch, 熱電対1ch", value: 2 },
        { text: "ひずみ2ch, 熱電対2ch", value: 3 },
        { text: "熱電対4ch", value: 7 },
      ],
      valid: false,
      validation: {
        deviceId: [(v) => !!v || "IDを選択してください。"],
        name: [
          (v) => !!v || "入力が必要な項目です。",
          (v) => (v && v.length >= 4) || "4文字以上が必要です。",
        ],
      },
    };
  },
  props: {
    modal: { Type: Boolean, default: false },
    deviceIds: { Type: Array, default: () => [] },
    siteGroups: { Type: Array, default: () => [] },
  },
  computed: {
    siteGroupOption() {
      return this.siteGroups.map((g) => g.name);
    },
  },
};
</script>

<style></style>
